import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export function useNavigationHistory() {
  const location = useLocation();
  useEffect(() => {
    const history = JSON.parse(sessionStorage.getItem('pathHistory') || '[]');
    const lastPath = history[history.length - 1];
    const currentPath = location.pathname;
    if (currentPath !== lastPath) {
      history.push(currentPath);
      sessionStorage.setItem('pathHistory', JSON.stringify(history));
    }
  }, [location.pathname]);
}
